import {
  CartElement,
  CheckoutProvider,
  CheckoutResponse,
  EditCartElementRequest,
  GetCartResponse,
  NoLoggedFreeRequest,
  Purchase,
  PutCartRequest,
} from '../../../models/payment.models';
import { BuilderType, InvalidationTag, mlkOnQueryStarted } from '../../utils';

export const buildCheckout = (builder: BuilderType) =>
  builder.mutation<CheckoutResponse, CheckoutProvider>({
    onQueryStarted: mlkOnQueryStarted,
    query: (provider) => ({
      url: `/cart/checkout/${provider}`,
      method: 'POST',
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildAddCart = (builder: BuilderType) =>
  builder.mutation<CartElement, PutCartRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/cart`,
      method: 'PUT',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildPurchaseFreeItem = (builder: BuilderType) =>
  builder.mutation<CartElement, PutCartRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/cart/purchaseFreeItem`,
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildNotLoggedPurchaseFreeItem = (builder: BuilderType) =>
  builder.mutation<CartElement, NoLoggedFreeRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: ({ body, id }) => ({
      url: `/orders/reschedule/${id}`,
      method: 'POST',
      body: body,
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildRemoveCartItem = (builder: BuilderType) =>
  builder.mutation<CartElement, number>({
    onQueryStarted: mlkOnQueryStarted,
    query: (itemId) => ({
      url: `/cart/remove/${itemId}`,
      method: 'DELETE',
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildGetCart = (builder: BuilderType) =>
  builder.query<GetCartResponse, undefined>({
    onQueryStarted: mlkOnQueryStarted,
    query: () => `/cart`,
    providesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildEditCartItem = (builder: BuilderType) =>
  builder.mutation<CartElement, EditCartElementRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: ({ cartElement }) => ({
      url: `/cart/item/${cartElement.id}`,
      method: 'POST',
      body: {
        product: cartElement.product,
        configuration: cartElement.configuration,
        orderId: cartElement.orderId,
      },
    }),
    invalidatesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildGetPurchases = (builder: BuilderType) =>
  builder.query<Purchase[], undefined>({
    onQueryStarted: mlkOnQueryStarted,
    query: () => `/purchases`,
    providesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildGetPurchase = (builder: BuilderType) =>
  builder.query<Purchase, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (purchaseId: string) => `/purchases/${purchaseId}`,
    providesTags: () => [
      { type: InvalidationTag.Cart },
      { type: InvalidationTag.Order },
    ],
  });

export const buildAskRefund = (builder: BuilderType) =>
  builder.mutation<Purchase, number>({
    onQueryStarted: mlkOnQueryStarted,
    query: (purchaseId: number) => ({
      url: `/purchases/requestRefund/${purchaseId}`,
      method: 'POST',
    }),
    invalidatesTags: () => [{ type: InvalidationTag.Order }],
  });
